module.exports = __webpack_public_path__ + "static/media/arialbd.ce4244a1.ttf";